import { Link } from 'react-router-dom';
import { hotTags } from '@/mocks/categories';

export default function HotTags() {
  return (
    <div className="bg-background-50 rounded-xl border border-background-200/70 p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-7 h-7 flex items-center justify-center bg-primary-500 rounded-md">
          <i className="ri-hashtag text-white text-sm"></i>
        </div>
        <h3 className="text-base font-bold font-heading text-foreground-900">
          热门标签
        </h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {hotTags.map((tag) => (
          <Link
            key={tag}
            to={`/category/mingxing-baoliao`}
            className="px-3 py-1.5 rounded-full bg-background-100 text-foreground-600 text-xs hover:bg-primary-100 hover:text-primary-700 transition-colors no-underline whitespace-nowrap"
          >
            #{tag}
          </Link>
        ))}
      </div>
    </div>
  );
}